

import React from 'react';
import ThankyouData from '../components/thankYou';
import usePageMeta from '../hooks/usePageMeta';
export default function ThankYouCarrers() {
    usePageMeta('Thank You for Applying to Join Us | Spinnennetz Digital', 'Thank you for submitting your application to Spinnennetz. Our team will review your details carefully and get back to you soon regarding your career options.', '/thank-you-careers', {"@context":"https://schema.org","@type":"WebPage","name":"Thank You for Applying"});
    return (
       <>
        <ThankyouData />
       </>
    )
}
